'use strict';
(() => {
  const dialog = document.getElementById('mh-cart');
  const content = dialog?.querySelector('[data-cart-content]');
  if (typeof HTMLDialogElement === 'undefined' || !(dialog instanceof HTMLDialogElement) || !content || typeof dialog.showModal !== 'function') return;

  let cartUrl;
  try {
    cartUrl = new URL(dialog.dataset.cartUrl, location.href);
    if (cartUrl.origin !== location.origin) return;
  } catch { return; }

  let opener = null;
  let requestVersion = 0;
  let controller = null;

  function stopRequest() {
    requestVersion += 1;
    controller?.abort();
    controller = null;
  }

  function showMessage(message, busy) {
    const paragraph = document.createElement('p');
    paragraph.className = 'cart-drawer-message';
    paragraph.textContent = message;
    const link = document.createElement('a');
    link.className = 'button dark cart-drawer-native-link';
    link.href = cartUrl.href;
    link.dataset.cartNativeLink = '';
    link.textContent = 'Go to bag';
    content.replaceChildren(paragraph, link);
    content.setAttribute('aria-busy', String(busy));
  }

  function parseSection(html) {
    const documentResult = new DOMParser().parseFromString(html, 'text/html');
    const matches = documentResult.querySelectorAll('[data-cart-section]');
    if (matches.length !== 1) throw new Error('Invalid bag section.');
    const section = matches[0];
    if (!/^\d+$/.test(section.dataset.cartCount || '') || !['true', 'false'].includes(section.dataset.salesEnabled)) throw new Error('Invalid bag state.');
    const count = Number(section.dataset.cartCount);
    if (!Number.isSafeInteger(count)) throw new Error('Invalid bag count.');
    if (section.querySelector('script, style, link, iframe, object, embed, form, input, button, textarea, select, dialog')) throw new Error('Unexpected bag controls.');
    for (const element of [section, ...section.querySelectorAll('*')]) {
      if ([...element.attributes].some(attribute => /^on/i.test(attribute.name))) throw new Error('Unexpected bag attributes.');
    }
    for (const link of section.querySelectorAll('a[href]')) {
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.origin !== location.origin) throw new Error('Invalid bag link.');
    }
    for (const image of section.querySelectorAll('img[src]')) {
      const url = new URL(image.getAttribute('src'), location.href);
      if (!['http:', 'https:'].includes(url.protocol)) throw new Error('Invalid bag image.');
    }
    const nativeLink = section.querySelector('a[data-cart-native-link]');
    if (!nativeLink || new URL(nativeLink.getAttribute('href'), location.href).pathname !== cartUrl.pathname) throw new Error('Missing native bag link.');
    const lines = [...section.querySelectorAll('[data-cart-line-quantity]')];
    const quantities = lines.map(line => Number(line.dataset.cartLineQuantity));
    if (quantities.some(quantity => !Number.isSafeInteger(quantity) || quantity < 1) || quantities.reduce((total, quantity) => total + quantity, 0) !== count) throw new Error('Incomplete bag contents.');
    if (count === 0 && !section.querySelector('[data-cart-empty]')) throw new Error('Missing empty bag state.');
    return { section, count };
  }

  async function refresh() {
    stopRequest();
    const version = requestVersion;
    const currentController = new AbortController();
    controller = currentController;
    showMessage('Loading your current bag…', true);
    const url = new URL(cartUrl.href);
    url.searchParams.set('section_id', 'mh-cart-drawer');
    const timeout = setTimeout(() => currentController.abort(), 12000);
    try {
      const response = await fetch(url.href, { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' }, signal: currentController.signal });
      if (!response.ok) throw new Error('Bag unavailable.');
      const { section, count } = parseSection(await response.text());
      if (version !== requestVersion || !dialog.open) return;
      content.replaceChildren(section);
      content.setAttribute('aria-busy', 'false');
      document.querySelectorAll('a[data-cart-open] [data-cart-item-count]').forEach(counter => { counter.textContent = String(count); });
    } catch {
      if (version === requestVersion && dialog.open) showMessage('The bag preview could not be loaded. Open the bag page to view your selection.', false);
    } finally {
      clearTimeout(timeout);
      if (controller === currentController) controller = null;
    }
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('a[data-cart-open]');
    if (trigger && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      if (dialog.open) return;
      const destination = new URL(trigger.href, location.href);
      if (destination.origin !== cartUrl.origin || destination.pathname !== cartUrl.pathname) return;
      try { dialog.showModal(); } catch { return; }
      event.preventDefault();
      opener = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      dialog.querySelector('[data-cart-close]')?.focus({ preventScroll: true });
      void refresh();
    }
    if (event.target.closest('#mh-cart [data-cart-close]') && dialog.open) dialog.close();
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); dialog.close(); });
  dialog.addEventListener('close', () => {
    stopRequest();
    content.setAttribute('aria-busy', 'false');
    opener?.setAttribute('aria-expanded', 'false');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  });
  addEventListener('pagehide', stopRequest);
})();
